module.exports = __webpack_public_path__ + "img/icon1-3.5c92cd81.png";